import { render, staticRenderFns } from "./che.vue?vue&type=template&id=c8b3f6fe&scoped=true&"
import script from "./che.vue?vue&type=script&lang=js&"
export * from "./che.vue?vue&type=script&lang=js&"
import style0 from "./che.vue?vue&type=style&index=0&id=c8b3f6fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b3f6fe",
  null
  
)

export default component.exports